import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  threadMessage: {
    id: 'screens.HubScreen.components.DcdThread.threadMessage',
    defaultMessage: '{name} finished a call',
  },
});
